var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgModo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 8,
    fill: "#008B55"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2291 20.019H12.3716C13.3164 20.019 14.085 20.7855 14.085 21.7361V27.2553C14.085 28.2021 13.3201 28.9724 12.3716 28.9724H12.2291C11.2842 28.9724 10.5156 28.2059 10.5156 27.2553V21.7323C10.5156 20.7855 11.2842 20.019 12.2291 20.019Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8856 18.58C25.8856 18.5574 25.8706 18.5424 25.8481 18.5424C25.8369 18.5424 25.8256 18.5499 25.8181 18.5574C24.3746 20.575 22.9349 22.5889 21.4914 24.6027C21.0902 25.1625 20.5503 25.4218 19.8716 25.3842C19.2867 25.3504 18.8181 25.0836 18.4656 24.5877C16.0136 21.1273 13.5502 17.6707 11.0794 14.2217C10.7682 13.7896 10.5882 13.4439 10.5357 13.1884C10.2321 11.7156 11.9268 10.487 13.2165 11.2873C13.4303 11.4188 13.6815 11.6856 13.9739 12.0951C15.9686 14.8792 17.9632 17.6595 19.9504 20.436C19.9729 20.4661 20.0104 20.4698 20.0404 20.451C20.0479 20.4473 20.0516 20.4435 20.0554 20.436C21.9975 17.7271 23.9435 15.0107 25.8931 12.2867C26.2868 11.7382 26.6167 11.3888 26.8904 11.2347C28.019 10.6073 29.47 11.4827 29.4738 12.8428C29.4925 17.5505 29.5 22.2545 29.5 26.9584C29.5 27.3642 29.455 27.6723 29.365 27.8827C28.7389 29.348 26.5305 29.3255 26.0093 27.8339C25.9269 27.5972 25.8894 27.1688 25.8894 26.5452C25.9044 23.8851 25.9006 21.2288 25.8856 18.58Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModo);
export default __webpack_public_path__ + "static/media/modo.5e98b82e04cd4cd515096f94bcdc84db.svg";
export { ForwardRef as ReactComponent };